import { X } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { BisacCode } from "reedy-data/api";
import { Text } from "components/text";
import { Badge } from "components/ui/badge";

interface AddBisacCodesSelectionProps {
  selected: BisacCode[];
  onRemove: (code: BisacCode) => void;
}

export const AddBisacCodesSelection = ({
  selected,
  onRemove,
}: AddBisacCodesSelectionProps) => {
  const { t } = useTranslation(["productDetails"]);

  return (
    <div className="flex-1 flex items-center h-11 min-w-0 border-dashed border border-secondary-300 rounded-md px-2 bg-white overflow-hidden">
      {selected.length === 0 ? (
        <Text as="span" variant="subtleItalic">
          {t("productDetails:bisac.addModal.noSelection")}
        </Text>
      ) : (
        <div className="flex items-center gap-2 overflow-x-auto">
          {selected.map((code) => (
            <Badge
              key={code.code}
              asChild
              variant="secondary"
              className="shrink-0 gap-1 px-2 py-1 font-mono cursor-pointer hover:bg-secondary-100"
            >
              <button
                type="button"
                onClick={() => onRemove(code)}
                aria-label={t("productDetails:bisac.addModal.removeSelected", {
                  code: code.code,
                })}
              >
                {code.code}
                <X className="size-3" />
              </button>
            </Badge>
          ))}
        </div>
      )}
    </div>
  );
};
